import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { ReportsService } from '../../../services/reports.service';
import { Pagination } from '../../../models/pagination';
import { ClientSelectionState } from '../../../state/ClientSelectionState/ClientSelection.state';
import { mergeMap } from 'rxjs/operators';
import { CreditDebitMemo } from '../../../models/reports';
import { downloadFile } from '../../../tools/reports-tools';

@Component({
  selector: 'lib-credit-debit-memo',
  templateUrl: './credit-debit-memo.component.html',
  styleUrls: ['./credit-debit-memo.component.css'],
  standalone: false
})
export class CreditDebitMemoComponent implements OnInit {
  public pagination: Pagination;
  public data: CreditDebitMemo[];
  public math = Math;

  constructor(
    private store: Store,
    private reportsService: ReportsService
  ) {}
  ngOnInit(): void {
    this.store
      .selectOnce(ClientSelectionState.clientCode)
      .pipe(
        mergeMap(code => {
          return this.reportsService.getCreditDebitMemos(code);
        })
      )
      .subscribe(memos => {
        this.pagination = memos.Pagination;
        this.data = memos.Items;
      });
  }

  download(memo: CreditDebitMemo) {
    this.store
      .selectOnce(ClientSelectionState.clientCode)
      .pipe(
        mergeMap(code => {
          return this.reportsService.downloadMemo(code, memo.FileName);
        })
      )
      .subscribe(result => {
        downloadFile(result);
      });
  }

  pageChanged(pagination: Pagination) {
    this.store
      .selectOnce(ClientSelectionState.clientCode)
      .pipe(
        mergeMap(code => {
          return this.reportsService.getCreditDebitMemos(code, pagination.Page);
        })
      )
      .subscribe(memos => {
        this.pagination = memos.Pagination;
        this.data = memos.Items;
      });
  }
}
